import React, { useEffect, useRef, useState } from 'react'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import { LANGUAGE_META, SupportedLanguage } from '../../geo/config'
import './index.css'
import { trackLanguageSelect } from '@monorepo/service'

const LanguageSelectorWrapper = () => {
  const [isOpen, setIsOpen] = useState(false)
  const switcherRef = useRef<HTMLDivElement>(null)
  const { allowedLanguages, language, languageMeta, setLanguage } = useGeoRuntime()
  const hasMultipleLanguages = allowedLanguages.length > 1
  useEffect(() => {
    if (!hasMultipleLanguages) {
      setIsOpen(false)
    }
  }, [hasMultipleLanguages])

  useEffect(() => {
    if (!isOpen) return

    const handleDocumentClick = (event: MouseEvent) => {
      if (!switcherRef.current?.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleDocumentClick)
    document.addEventListener('keyup', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick)
      document.removeEventListener('keyup', handleEscape)
    }
  }, [isOpen])

  const handleLanguageSelect = (selectedLanguage: SupportedLanguage) => {
    setLanguage(selectedLanguage)
    setIsOpen(false)
    trackLanguageSelect('registration', selectedLanguage)
  }

  return (
    <div ref={switcherRef} className="langSelector">
      <button
        type="button"
        className={`selected${isOpen ? ' active' : ''}`}
        onClick={() => {
          if (hasMultipleLanguages) {
            setIsOpen((prev) => !prev)
          }
        }}
        aria-expanded={hasMultipleLanguages ? isOpen : undefined}
        aria-haspopup={hasMultipleLanguages ? 'listbox' : undefined}
      >
        <img src={languageMeta.flag} alt={languageMeta.label.toLowerCase()} />
        <span>{languageMeta.label}</span>
        {hasMultipleLanguages ? (
          <div className="selected-icon">
            <img
              src="data:image/svg+xml,%3csvg%20width='12'%20height='8'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.41.58L6%205.17%2010.59.58%2012%202%206%208%200%202%201.41.58z'%20fill='%23fff'/%3e%3c/svg%3e"
              alt=""
              aria-hidden="true"
            />
          </div>
        ) : null}
      </button>
      {hasMultipleLanguages ? (
        <ul className={`dropdown-list${isOpen ? ' active' : ''}`} role="listbox">
          {allowedLanguages.map((allowedLanguage) => (
            <li key={allowedLanguage} className={allowedLanguage === language ? 'active' : ''}>
              <button
                type="button"
                onClick={() => {
                  handleLanguageSelect(allowedLanguage)
                }}
              >
                <img src={LANGUAGE_META[allowedLanguage].flag} alt={allowedLanguage} />
                <span>{LANGUAGE_META[allowedLanguage].label}</span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}

export default LanguageSelectorWrapper
